import { ClientUpgradeContent299vg0lx1tyfp as ClientUpgradeContent } from '../../request/ClientUpgradeContent.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { generateNonce3td15vdvbmmke as generateNonce } from '../../../../../../ktor-ktor-utils/io/ktor/util/Crypto.mjs';
import { Default_getInstance3483fw4bkmewo as Default_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/encoding/Base64.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { HeadersBuilder3h7sn3kkvu98m as HeadersBuilder } from '../../../../../../ktor-ktor-http/io/ktor/http/Headers.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var WebSocketContentClass;
function WebSocketContent() {
  if (WebSocketContentClass === VOID) {
    class $ extends ClientUpgradeContent() {
      constructor() {
        super();
        var tmp = this;
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().l1();
        var nonce = generateNonce(16);
        this_0.m1(Default_getInstance().no(nonce));
        tmp.l5w_1 = this_0.toString();
        var tmp_0 = this;
        // Inline function 'kotlin.apply' call
        var this_1 = new (HeadersBuilder())();
        this_1.m4s('Upgrade', 'websocket');
        this_1.m4s('Connection', 'Upgrade');
        this_1.m4s('Sec-WebSocket-Key', this.l5w_1);
        this_1.m4s('Sec-WebSocket-Version', '13');
        tmp_0.m5w_1 = this_1.v39();
      }
      u54() {
        return this.m5w_1;
      }
      toString() {
        return 'WebSocketContent';
      }
    }
    initMetadataForClass($, 'WebSocketContent', WebSocketContent, VOID, VOID, [1]);
    WebSocketContentClass = $;
  }
  return WebSocketContentClass;
}
//region block: exports
export {
  WebSocketContent as WebSocketContentagsn4p79ffe0,
};
//endregion

//# sourceMappingURL=WebSocketContent.mjs.map
